<template>
  <v-container fluid grid-list-md>
    <!-- Dialog para solicitar a inclusão de telefone  -->
    <v-dialog v-model="dialogNotPhoneUsers" persistent width="500">
      <v-card>
        <v-card-text>
          <div class="text-column">
            <h4>Para incluir lembrete por WhatsApp, favor solicitar que os usuários abaixo incluam o telefone:</h4>
            <br>
            <p v-for="(userText, index) in listNotPhoneUsers" :key="index" class="ma-0">{{userText}}</p>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialogNotPhoneUsers = false">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIMMM Dialog para solicitar a inclusão de telefone  -->
    <p-upgrade-dialog :upgradeDialog="upgradeDialog" @closeDialog="upgradeDialog = false" :link_src="`${basePath}images/upgrade_wpp.mp4`"></p-upgrade-dialog>
    <p-user-edit ref="userEdit" @onSave="() => {editedItem.type = 2}"></p-user-edit>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">{{translate('table.' + entity + '.title')[1]}}</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <v-btn color="primary" @click="create" class="mb-4" :disabled="task_shared">
          {{this.translate('system.button.add.title')}}
          <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
      </v-flex>
      <v-layout row>
        <v-flex xs12>
          <v-card>
            <v-list two-line subheader :search="search">
              <v-layout>
                <v-flex xs10>
                  <v-subheader>Descrição</v-subheader>
                </v-flex>
                <v-flex xs2>
                  <v-subheader>Ações</v-subheader>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <template v-for="(item, index) in customFilter">
                <v-list-tile :key="index">
                  <v-list-tile-content>
                    <v-list-tile-title style="color: black;font-weight: bold;font-family: Arial">{{item.user['id_text']}}</v-list-tile-title>
                    <v-list-tile-title>{{ item.date | formatDateTime }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ translate('value.reminder_type').filter(a=>a.value === item.type)[0].text }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <!-- <v-list-tile-content>
                  <v-list-tile-title style="color: black;font-family: Arial"><strong>{{translate('value.reminder_type').filter(a=>a.value === item.type)[0].text}}</strong>{{translate('module.task.reminder.message')}}<strong>{{item.user['id_text']}}</strong> dia <strong>{{ item.date | formatDateTime }}</strong></v-list-tile-title>
                  </v-list-tile-content> -->
                  <v-list-tile-action>
                    <v-btn icon class="mx-0">
                      <v-icon color="pink" @click="dialogDelete(item)" :disabled="task_shared || !task.crud_access">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <!-- // soma com mil pois já é usado o index no list -->
                <v-divider :key="index + 1000" v-if="index + 1 < customFilter.length"></v-divider>
              </template>
              <v-list-tile three-line v-if="customFilter.length === 0">
                {{emptyTable}}
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" @keyup.native.esc="close(400)" @keyup.native.ctrl.enter="processSave()" ref="form">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs12>
                  <v-select :label="translate('table.' + entity + '.field.user_id')" :loading="loading" :disabled="loading"
                            v-model="editedItem.users_id" :items="teamUsers" @input="onChangeType(editedItem.type)" item-text="id_text" item-value="id"
                            :rules="requiredRule(translate('table.' + entity + '.field.user_id'))" multiple></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select :label="translate('table.' + entity + '.field.type')"
                            v-model="editedItem.type" @change="onChangeType" :items="translate('value.reminder_type')"
                            :rules="requiredRule(translate('table.' + entity + '.field.type'))"></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <p-date-time :label="translate('table.' + entity + '.field.date')"
                          v-model="editedItem.date" :rules="pastDateRule(true)" @keyup.native.ctrl.enter="processSave()"></p-date-time>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="processSave()">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="close(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
  .reminderExample {
    color: #999;
    font-weight: 500;
  }
</style>

<script>
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import plan from './../../mixin/plan'
  import moment from 'moment'
  import PConfirm from './../shared/PConfirm'
  import PUpgradeDialog from './../shared/PUpgradeDialog'
  import PUserEdit from './../shared/PUserEdit'
  import PDateTime from './../shared/PDateTime'

  export default {
    mixins: [crud, rules, plan],
    components: {
      PConfirm, PDateTime, PUpgradeDialog, PUserEdit
    },
    data: () => ({
      entity: 'task_reminder',
      basePath: process.env.API,
      upgradeDialog: false,
      dialogNotPhoneUsers: false,
      listNotPhoneUsers: [],
      teamUsers: [],
      loading: false
    }),
    name: 'Reminder',
    props: {
      task: Object,
      task_shared: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.items = this.task.reminders
      // se a tarefa for compartilhada o usuário não tem o login
      if (!this.task_shared) {
        this.editedItem = {task_id: this.task.id, users_id: [this.$auth.check() ? this.$auth.user().id : 0], user_id: '', type: 1, date: ''}
        this.defaultItem = {task_id: this.task.id, users_id: [this.$auth.check() ? this.$auth.user().id : 0], user_id: '', type: 1, date: ''}
      }
    },
    mounted: function () {
      this.$emit('itemsLength', this.items.length)
    },
    methods: {
      // processSave craido para salvar registro por registro
      processSave () {
        if ((this.$refs.form && !this.$refs.form.validate())) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        // percorre cada usuário selecionado e insere o user e salva
        this.editedItem['users_id'].forEach((userId) => {
          this.editedItem['user_id'] = userId
          this.save()
        })
      },
      beforeCreate () {
        // Carrega todos os usuário que participam da tarefa para serem adicionados nas menções
        this.loading = true
        this.$http.get(`api/get_users_task/${this.task.id}`).then((res) => {
          this.teamUsers = res.body
          this.loading = false
        }, err => {
          this.loading = false
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível carregar os registros, reporte o erro.',
            color: 'error',
            dialog: true
          })
          console.log(err)
        })
      },
      afterAddSocketDetails (item) {
        this.$emit('itemsLength', this.items.length)
      },
      onChangeType (val) {
        this.listNotPhoneUsers = []
        // se for wpp verifica se o plano não é gratis e verifica se os usuários elecionados possuem telefone
        if (val === 2) {
          if (this.checkIsFree()) {
            setTimeout(() => {
              this.editedItem.type = 1
            }, 100)
            this.upgradeDialog = true
            // Caso o usuário tenha sido selecionado e ele não tenha telefone mostra pra ele adicionar um telefone
          } else if (this.editedItem['users_id'].length === 1 && this.editedItem['users_id'][0] === this.$auth.user().id && !this.$auth.user().phone) {
            this.$refs.userEdit.open()
            setTimeout(() => {
              this.editedItem.type = 1
            }, 100)
          } else {
            this.editedItem['users_id'].forEach((userId) => {
              let user = this.teamUsers.find((val) => val.id === userId)
              if (user) {
                if (!user['phone']) {
                  this.listNotPhoneUsers.push(user.id_text)
                }
              }
            })
            setTimeout(() => {
              // caso tenha algum usuário que não possui telefone manda uma msg com a lista de nomes
              if (this.listNotPhoneUsers.length > 0) {
                this.dialogNotPhoneUsers = true
                this.editedItem.type = 1
              }
            }, 500)
          }
        }
      },
      afterDeleteSocketDetails (item) {
        this.$emit('itemsLength', this.items.length)
      },
      afterDelete (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'reminders',
          responseEvent: 'deleteSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        this.$emit('itemsLength', this.items.length)
      },
      afterUpdate (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'reminders',
          responseEvent: 'editSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
      },
      afterInsert (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'reminders',
          responseEvent: 'addSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        this.$emit('itemsLength', this.items.length)
      }
    },
    computed: {
      customFilter: function () {
        let items = this.items.filter((item) => {
          let itemText = item.user['id_text'] + ' ' + moment(item.date).format('DD/MM/YYYY - HH:mm:ss') + ' ' + this.translate('value.reminder_type').filter(a => a.value === item.type)[0].text
          const hasValue = val => val != null ? val : ''
          const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          const search = hasValue(this.search).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          return text.indexOf(search) > -1
        })
        // ordena os valores pela data
        return items.sort((a, b) => moment(b.date).diff(a.date))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TaskReminder.vue